var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"call-amount-trend-line"},[_c('div',{ref:"container",staticStyle:{"width":"100%","height":"230px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }